import React from "react";

const Blogs = () => {
  // Blog data
  const blogSeries = [
    {
      id: "cov_series", // Unique identifier for the series
      title: "Calculus of Variations and Optimal Control",
      description:
        "A series exploring the fundamentals of calculus of variations and its applications in optimal control.",
      posts: [
        {
          id: "cov1",
          title: "Introduction to Calculus of Variations",
          link: "/blogs/cov_series/cov1", // Link to the CoV1.js page
          date: "January 1, 2025",
        },
        // Add more posts as you create them
        {
          id: "cov2",
          title: "Euler-Lagrange Equations",
          link: "/blogs/cov_series/cov2",
          date: "January 10, 2025",
        },
      ],
    },
  ];

  return (
    <div className="container mx-auto px-4 py-12">
      {/* Header Section */}
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold mb-4 text-white">Blogs</h1>
        <p className="text-xl text-gray-300 max-w-2xl mx-auto">
          Sharing insights, tutorials, and thoughts on topics in AI, mathematics, and beyond.
        </p>
      </div>

      {/* Blog Series Section */}
      <div>
        <h2 className="text-3xl font-bold text-white mb-8">Blog Series</h2>
        <div className="grid gap-8">
          {blogSeries.map((series) => (
            <div
              key={series.id}
              className="glass glass-hover p-8 rounded-2xl border border-white/5 border-l-4 border-l-green-500 shadow-2xl transition-all duration-300"
            >
              <h3 className="text-2xl font-bold text-blue-100">{series.title}</h3>
              <p className="text-gray-300 mt-4 leading-relaxed">{series.description}</p>

              {/* Expandable Posts */}
              <div className="mt-6">
                {series.posts.map((post) => (
                  <div
                    key={post.id}
                    className="mb-4 pl-4 border-l-2 border-white/10 hover:border-green-500 transition-colors bg-white/5 p-4 rounded-r-xl"
                  >
                    <h4 className="text-lg font-bold">
                      <a href={post.link} className="text-blue-400 hover:text-blue-300 transition-colors">
                        {post.title}
                      </a>
                    </h4>
                    <p className="text-sm text-gray-500 mt-1 font-medium">{post.date}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blogs;
